import { takeLatest } from 'redux-saga/effects';
import {
  CHANGE_ROUTE_SUCCESS,
  AUTH_SIGNOUT_SUCCESS,
  AUTH_SIGNIN_FAILURE,
  AUTH_REFRESH_FAILURE,
  AUTH_SIGNIN_SUCCESS,
  AUTH_SIGNED_FAILURE,
  APPROVE_INVOICE_DOCUMENT_SUCCESS,
} from 'redux-api/action/actionTypes';
import Router from 'next/router';
import { OAUTH_CONFIG } from 'lib/oauth-config';
import { logoutUrl } from 'lib/sso';

function sendRouteSaga(action) {
  const isServer = typeof window === 'undefined';

  if (!isServer && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(JSON.stringify(action));
  }
}

// To /login, keeping the page to come back to. It used to send the browser to
// `${SIGNIN_URI}?redirect_uri=…`, streetlib-auth-next's hand-off that appends the
// tokens to that address; streetlib-id does not honour it, so a session that failed
// to refresh would sign in and land on the sign-in host's welcome page instead of
// here. The button rather than ?sso=1, on purpose: this runs when a sign-in has just
// failed, and starting another one on its own could loop.
function redirectToSignin() {
  const { pathname } = document.location;
  const next = pathname && pathname !== '/login' ? `?next=${encodeURIComponent(pathname)}` : '';
  Router.push(`/login${next}`);
}

// After this site's session is cleared, the sign-in host's session is ended too:
// through its /logout, which comes back to /login. Every sign-out button lands
// here — the header button, the user menu and /signout all dispatch
// signoutRequest — so this is the one place it can be done. Ending only the local
// session left the sign-in host signed in, and pressing "sign in" again, or
// opening any other platform, entered straight back into the same account.
function signOutOfAuthHost() {
  if (typeof window === 'undefined') return;
  window.location.href = logoutUrl({
    authUrl: OAUTH_CONFIG.AUTH_URL,
    clientId: OAUTH_CONFIG.CLIENT_ID,
    origin: window.location.origin,
  });
}

function redirectToSignout() {
  // A refresh that failed is not somebody signing out, and ending the sign-in
  // host's session for them would sign them out of every other platform too.
  // eslint-disable-next-line no-console
  console.log('🚫 Legacy signout redirect disabled - using new OAuth flow');
}

function redirectToPage({ payload }) {
  Router.replace({
    pathname: payload && payload.pathname ? payload.pathname : '/',
    query: payload && payload.query ? payload.query : {},
  });
}

function redirectPassiveInvoice({ payload }) {
  const {
    invoice: {
      data: { id },
    },
  } = payload;

  Router.push({ pathname: '/billing/passive', query: { id } });
}

export default function* watchRoute() {
  yield takeLatest(CHANGE_ROUTE_SUCCESS, sendRouteSaga);
  yield takeLatest(AUTH_SIGNIN_SUCCESS, redirectToPage);
  yield takeLatest(AUTH_SIGNIN_FAILURE, redirectToSignin);
  yield takeLatest(AUTH_SIGNED_FAILURE, redirectToSignin);
  yield takeLatest(AUTH_SIGNOUT_SUCCESS, signOutOfAuthHost);
  yield takeLatest(AUTH_REFRESH_FAILURE, redirectToSignout);
  yield takeLatest(APPROVE_INVOICE_DOCUMENT_SUCCESS, redirectPassiveInvoice);
}
